import React from 'react';
import styled from 'styled-components';
import styledProps from 'styled-props';
import { Flex } from 'rebass';
// import safeProps from '../safeProps';

const starDefinitions = {
  small: {
    width: '12px',
    height: '12px',
    marginTop: '-4px',
    containerWidth: '70px',
    containerHeight: '14px'
  },
  medium: {
    width: '16px',
    height: '16px',
    marginTop: '-2px',
    containerWidth: '90px',
    containerHeight: '16px'
  },
  large: {
    width: '24px',
    height: '24px',
    marginTop: '1px',
    containerWidth: '130px',
    containerHeight: '26px'
  }
};

const starWidths = {
  small: starDefinitions.small.width,
  medium: starDefinitions.medium.width,
  large: starDefinitions.large.width
};

const starHeights = {
  small: starDefinitions.small.height,
  medium: starDefinitions.medium.height,
  large: starDefinitions.large.height
};

const starMargins = {
  small: starDefinitions.small.marginTop,
  medium: starDefinitions.medium.marginTop,
  large: starDefinitions.large.marginTop
};

const starContainerWidths = {
  small: starDefinitions.small.containerWidth,
  medium: starDefinitions.medium.containerWidth,
  large: starDefinitions.large.containerWidth
};

const starContainerHeights = {
  small: starDefinitions.small.containerHeight,
  medium: starDefinitions.medium.containerHeight,
  large: starDefinitions.large.containerHeight
};

const Star = styled.div`
  width: ${styledProps(starWidths)};
  height: ${styledProps(starHeights)};
  max-height: ${styledProps(starHeights, 'large')}
  max-width: ${styledProps(starWidths, 'large')}
  margin: 1px;
  margin-top: ${styledProps(starMargins)};
`;
const StarContainer = styled(Flex)`
  width: ${styledProps(starContainerWidths)};
  height: ${styledProps(starContainerHeights)};
`;

function safeProps(props) {
  const newProps = { ...props };
  for (let k in props) {
    if (props[k] === true) {
      newProps[k] = 'true';
    } else if (props[k] === false) {
      newProps[k] = 'false';
    }
  }
  delete newProps.changeMinRating;
  return newProps;
}

export default function(props) {
  const changeMinRating = props.changeMinRating;
  const safe = safeProps(props);
  const stars = [];
  for (let i = 1; i < 6; i++) {
    stars.push(
      <Star {...safe} key={i} onClick={() => changeMinRating(i)}>
        {i <= props.rating ? (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15">
            <path
              fill="#F15E26"
              fillRule="evenodd"
              d="M8 12l-4.702 2.472.898-5.236L.392 5.528l5.257-.764L8 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236z"
            />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 22">
            <path
              fill="none"
              fillRule="evenodd"
              stroke="#F15E26"
              d="M18.39 20.794l-1.22-7.114 5.168-5.04-7.143-1.037L12 1.13 8.805 7.603 1.662 8.64 6.83 13.68l-1.22 7.114L12 17.435l6.39 3.36z"
            />
          </svg>
        )}
      </Star>
    );
  }

  return <StarContainer {...safe}>{stars}</StarContainer>;
}



// WEBPACK FOOTER //
// ./src/components_new/common/RatingsPicker.js